import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import {
  IBlacklistAddEditPayload,
  IGetDataPayload,
} from '@app/dashboard/types/innerLayout/risk_center';

export const getBlacklistData = (data: IGetDataPayload) => {
  const { params, currentPage, pageSize, ...rest } = data;
  const payload = {
    ...rest,
    ...params,
    page: currentPage,
    page_size: pageSize,
  };

  return axiosPrivate.get(`/dashboard/api/v1/risk-center/blacklists`, {
    params: payload,
  });
};

export const addBlackList = (payload: IBlacklistAddEditPayload) => {
  return axiosPrivate.post(`/dashboard/api/v1/risk-center/blacklists`, payload);
};

export const removeBlackList = (id: number) => {
  return axiosPrivate.delete(`/dashboard/api/v1/risk-center/blacklists/${id}`);
};

export const editBlackList = (
  id: number,
  payload: IBlacklistAddEditPayload
) => {
  return axiosPrivate.put(
    `/dashboard/api/v1/risk-center/blacklists/${id}`,
    payload
  );
};
